import { useEffect } from 'react';
import { userManager } from './AuthProvider';

export function SilentRenewPage() {
  useEffect(() => {
    const completeSilentRenew = async () => {
      try {
        await userManager.signinSilentCallback();
      } catch (error) {
        console.error('Silent renew callback error:', error);
      }
    };

    completeSilentRenew();
  }, []);

  return <div className="sr-only">Silent renew callback</div>;
}
